import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from '../stores/auth';

// 直接使用 () => import() 方式异步加载，避免 defineAsyncComponent 包裹的警告
const asyncComponent = (path) => () => import(`@/views/${path}`);

const routes = [
  {
    path: "/",
    redirect: "dashboard/login"
  },
  {
    path: "/loading",
    name: "loading",
    component: asyncComponent("login/loading.vue")
  },
  // 已移除 OIDC callback 路由
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: "/dashboard/login",
    component: asyncComponent("dashboard/index.vue"),
    children: [
      {
        path: "login",
        name: "DashboardLogin",
        component: asyncComponent("dashboard/login.vue")
      },
      {
        path: "register",
        name: "DashboardRegister",
        component: asyncComponent("dashboard/register.vue")
      },
      {
        path: "contactus",
        name: "contactus",
        component: asyncComponent("dashboard/contactus.vue")
      },
      {
        name: "rate",
        path: "rate",
        component: asyncComponent("dashboard/rate.vue")
      },
      {
        path: "tools",
        name: "dashboardTools",
        component: asyncComponent("dashboard/tools.vue")
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    redirect: "/login/loginHome",
    component: asyncComponent("login/login.vue"),
    children: [
      {
        path: "loginHome",
        name: "loginHome",
        component: asyncComponent("login/loginHome.vue")
      },
      {
        path: "logincontact",
        name: "logincontact",
        component: asyncComponent("login/contact.vue")
      },
      {
        path: "loginregister",
        name: "loginregister",
        component: asyncComponent("login/registered.vue")
      },
      {
        path: "loginRecharge",
        name: "loginRecharge",
        component: asyncComponent("login/recharges.vue")
      },
      {
        path: "unloading",
        name: "unloading",
        component: asyncComponent("login/unloading.vue")
      },
      {
        path: "iplimited",
        name: "iplimited",
        component: asyncComponent("login/iplimited.vue")
      },
      {
        path: "deleted",
        name: "deleted",
        component: asyncComponent("login/deleted.vue")
      },
      {
        path: "ipsecurity",
        name: "ipsecurity",
        component: asyncComponent("login/ipsecurity.vue")
      },
      {
        path: "disabled",
        name: "disabled",
        component: asyncComponent("login/disabled.vue")
      },
      {
        path: "loginTool",
        name: "loginTool",
        component: asyncComponent("login/tool.vue")
      }
    ]
  },
  {
    path: "/main",
    name: "main",
    redirect: "/main/home",
    component: asyncComponent("main.vue"),
    children: [
      {
        path: "home",
        name: "home",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("home.vue")
      },
      {
        path: "partmodules",
        name: "partmodules",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partmodule.vue")
      },
      {
        path: "partinstalls",
        name: "partinstalls",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partinstall.vue")
      },
      {
        path: "partmoduleEdit",
        name: "partmoduleEdit",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partmoduleEdit.vue")
      },
      {
        path: "Replacementofrecords",
        name: "Replacementofrecords",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Replacementofrecords.vue")
      },
      {
        path: "Groupmanagement",
        name: "Groupmanagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Groupmanagement.vue")
      },
      {
        path: "MobileGameDown",
        name: "MobileGameDown",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("mobileGameDown.vue")
      },
      {
        path: "fenyong",
        name: "fenyong",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("fenyong.vue")
      },
      {
        path: "Zoningmanagement",
        name: "Zoningmanagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Zoningmanagement.vue")
      },
      {
        path: "Withdrawalrecords",
        name: "Withdrawalrecords",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Withdrawalrecords.vue")
      },
      {
        path: "Orderreissue",
        name: "Orderreissue",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Orderreissue.vue")
      },
      {
        path: "handOrder",
        name: "handOrder",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("handOrder.vue")
      },
      {
        path: "Ordermanagement",
        name: "Ordermanagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Ordermanagement.vue")
      },
      {
        path: "partinstallmod",
        name: "partinstallmod",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partinstallmod.vue")
      },
      {
        path: "gaincode",
        name: "gaincode",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("gaincode.vue")
      },
      {
        path: "DA",
        name: "DA",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("DA.vue")
      },
      {
        path: "partinstallEdit",
        name: "partinstallEdit",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partinstallEdit.vue")
      },
      {
        path: "partinstallClone",
        name: "partinstallClone",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partinstallClone.vue")
      },
      {
        path: "rateList",
        name: "rateList",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("rateList.vue")
      },
      {
        path: "message",
        name: "message",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("mailMessage.vue")
      },
      {
        path: "withdrawapply",
        name: "withdrawapply",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("Withdrawapply.vue")
      },

      {
        path: "partmoduleClone",
        name: "partmoduleClone",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("partmoduleClone.vue")
      },
      {
        path: "orderInterval",
        name: "orderInterval",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("OrderInterval.vue")
      },
      {
        path: "employee",
        name: "employee",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("employee.vue")
      }
    ]
  },
  {
    path: "/employeemain",
    name: "employeemain",
    redirect: "/employeemain/employeehome",
    component: asyncComponent("employeemain.vue"),
    children: [
      {
        path: "employeehome",
        name: "employeehome",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("employeehome.vue")
      },
      {
        path: "employeeOrdermanagement",
        name: "employeeOrdermanagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("employeeOrdermanagement.vue")
      },
       {
        path: "employeeGroupmanagement",
        name: "employeeGroupmanagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("employeeGroupmanagement.vue")
      },
    ]
  },
  {
    path: "/personal",
    name: "personal",
    redirect: "/personal/baseInfo",
    component: asyncComponent("individual/main.vue"),
    children: [
      {
        path: "baseInfo",
        name: "personalBaseInfo",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/baseInfo.vue")
      },
      {
        path: "password",
        name: "personalPassword",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/password.vue")
      },
      {
        path: "weixin",
        name: "personalWeixin",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/weixin.vue")
      },
      {
        path: "wechat",
        name: "personalWechat",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/wechat.vue")
      },
      {
        path: "recoder",
        name: "personalRecoder",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/recoder.vue")
      },
      {
        path: "Userlogs",
        name: "personalUserlogs",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/Userlogs.vue")
      },
      {
        path: "conectKey",
        name: "personalConectKey",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/conectKey.vue")
      },
      {
        path: "openApi",
        name: "personalOpenApi",
        meta: {
          requiresAuth: true,
          role: ["Tenant", "Agent"]
        },
        component: asyncComponent("individual/openApi.vue")
      },
      {
        path: "acountsafe",
        name: "personalAcountsafe",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/acountsafe.vue")
      },
      {
        path: "finishInfo",
        name: "personalFinishInfo",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/finishInfo.vue")
      },
      {
        path: "elecsign",
        name: "personalElecsign",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("individual/elecSign.vue")
      }
    ]
  },
  {
    path: "/agentsystem",
    name: "agentsystem",
    redirect: "/agentsystem/merchant",
    component: asyncComponent("agentSys/main.vue"),
    children: [
      {
        path: "merchant",
        name: "merchant",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("agentSys/merchant.vue")
      },
      {
        path: "agentOrder",
        name: "agentOrder",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("agentSys/agentOrder.vue")
      },
      {
        path: "userGroup",
        name: "userGroup",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("agentSys/userGroup.vue")
      },
      {
        path: "Statistics",
        name: "Statistics",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("agentSys/Statistics.vue")
      },
      {
        path: "agentManagement",
        name: "agentManagement",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("agentSys/agentManagement.vue")
      }
    ]
  },
  {
    path: "/accessdenied",
    name: "accessdenied",
    meta: {
      requiresAuth: false,
      role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
    },
    component: asyncComponent("login/accessdenied.vue")
  },
  {
    path: "/forbidden",
    name: "forbidden",
    meta: {
      requiresAuth: false,
      role: ["Tenant", "Agent"]
    },
    component: asyncComponent("login/forbidden.vue")
  },
  {
    path: "/agentLogin",
    name: "agentLogin",
    meta: {
      requiresAuth: false,
      role: ["Tenant", "Agent"]
    },
    component: asyncComponent("agentLogin.vue")
  },
  {
    path: "/behalf",
    name: "behalf",
    redirect: "/behalf/baseInfo",
    component: asyncComponent("behalf/main.vue"),
    children: [
      {
        path: "baseInfo",
        name: "behalfBaseInfo",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/baseInfo.vue")
      },
      {
        path: "version",
        name: "behalfVersion",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/version.vue")
      },
      {
        path: "detail",
        name: "behalfDetail",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/detail.vue")
      },
      {
        path: "editVersion",
        name: "behalfEditVersion",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/editVersion.vue")
      }
    ]
  },
  {
    path: "/audit",
    name: "audit",
    redirect: "/audit/audit",
    component: asyncComponent("behalf/main_audit.vue"),
    children: [
      {
        path: "audit",
        name: "auditPage",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/audit.vue")
      },
      {
        path: "success",
        name: "auditSuccess",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/success.vue")
      },
      {
        path: "task",
        name: "auditTask",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/task.vue")
      },
      {
        path: "error",
        name: "auditError",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/error.vue")
      },
      {
        path: "blacklist",
        name: "auditBlacklist",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/blacklist.vue")
      }
    ]
  },
  {
    path: "/rollout",
    name: "rollout",
    redirect: "/rollout/everyday",
    component: asyncComponent("behalf/main_out.vue"),
    children: [
      {
        path: "everyday",
        name: "rolloutEveryday",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/everyday.vue")
      },
      {
        path: "partition",
        name: "rolloutPartition",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/partition.vue")
      },
      {
        path: "role",
        name: "rolloutRole",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/role.vue")
      },
      {
        path: "alipay",
        name: "rolloutAlipay",
        meta: {
          requiresAuth: true,
          role: ["SuperAdmin", "Admin", "Tenant", "Agent","Employee"]
        },
        component: asyncComponent("behalf/alipay.vue")
      }     
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 全局路由守卫：简单 token 检查 + 角色校验
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  if (to.meta?.requiresAuth) {
    if (!authStore.isAuthenticated) {
      return next('/dashboard/login');
    }
    // 角色校验（若路由声明了 role 并且当前用户有 role 信息）
    if (to.meta.role && authStore.user?.role && Array.isArray(to.meta.role)) {
      if (!to.meta.role.includes(authStore.user.role)) {
        return next('/accessdenied');
      }
    }
  }
  next();
});

export default router;
